import React from 'react';
import { ElementsConsumer } from '@stripe/react-stripe-js';
import CardSection from './CardSection';

const CheckoutForm = (...args: any[]) => {
  return (
    <>
      <CardSection />
    </>
  );
};

const InjectedCheckoutForm = () => {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <CheckoutForm style={{
          margin: '0px'
        }} />
      )}
    </ElementsConsumer>
  );
};

export default InjectedCheckoutForm;
